module.exports = __webpack_public_path__ + "img/03.a945b013.jpg";